export default "/images/b2b3c4efb2e78d0355e5ca01b5c48f2a.png";